// extracted by mini-css-extract-plugin
module.exports = {"components":"-market-share-chart-component-components-LWJiER-"};